module.exports = __webpack_public_path__ + "static/media/aws.05a37055.png";